<template>
    <div class="list-content">
      <p class="card-line">
        <span class="line-text">{{$t('Trading_System')}}</span>
        <span class="line"></span>
        <span>
                  {{'MT4'}}
        </span>
      </p>
         <p class="card-line">
            <span class="line-text">{{$t('transaction_account')}}</span>
            <span class="line"></span>
            <span>
                  {{accountInfo.login}}
            </span>
        </p>
        <p class="card-line">
        <span class="line-text">{{$t('server')}}</span>
        <span class="line"></span>
        <span>
                        {{accountInfo.serverName}}
                        </span>
      </p>
        <p class="card-line">
          <span class="line-text">{{$t('account_type')}}</span>
          <span class="line"></span>
          <span>
                          {{accountInfo.accType}}
                          </span>
        </p>

        <p class="card-line">
            <span class="line-text">{{$t('User.leverage')}}</span>
            <span class="line"></span>
            <span>
                    1:{{accountInfo.leverage}}
                </span>
        </p>
    </div>
</template>

<script>
  import mt4Status from '@/components/public/mt4Status'
  import { queryStatistics,queryStatisticsSimple } from '@/api/copy'
  export default {
    name: 'accountIndexDataNew',
    components:{
      mt4Status,
    },
    data() {
      return {
        accountInfo: {
          balance: 0,
          closeOrder: 3,
          createTime: "",
          credit: 0,
          earningRate: 0,
          enableReadOnly: 0,
          equity: 0,
          leverage: 0,
          login: 0,
          marginFree: 0,
          maxRetracement: 0,
          openOrder: 0,
          profitRate: 0,
          statProfit: 0,
          subLoginNumber: 1,
          times: 1,
        }
      };
    },
    created(){
      this.getStatisticsData();
    },
    computed: {
      disabledStyle(){
        if(this.accountInfo.businessType !== 6){
          return {
            width: '300px'
          }
        }else {
          return {};
        }
      },
    },
    methods: {
      getStatisticsData() {
        if(this.$route.name == 'mamMasterDetailsSimple' || this.$route.name == 'socialMasterDetailsSimple'){
          queryStatisticsSimple({
            mtId: this.$route.params.mtid,
          }).then((res) => {
            this.accountInfo = res.data[0];
            this.$emit('send-indexdata', this.accountInfo);
          })
        }else {
          queryStatistics({
            mtId: this.$route.params.mtid,
          }).then((res) => {
            this.accountInfo = res.data[0];
            this.$emit('send-indexdata', this.accountInfo);
          })
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.list-content {
    .card-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 28px;
        font-size: 13px;
        .line {
            flex: 1;
            height: 0;
            border-bottom: 1px dashed #E6E6E6;
            margin: 0 5px;
        }

        & > span {
            display: block;

            .icon {
                display: block;
                cursor: pointer;
                width: 16px;
                height: 16px;
            }

            &:last-of-type {
                white-space: nowrap;
            }
        }
        &.status {
            margin: 20px 0;
        }
        .line-text {
          color: #A29FAE;
        }
    }
}
</style>
